
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SexualDevelopment',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/SexualDevelopment.vue